export const transformDevice = (sensor: string[]) => {
  try {
    if (sensor?.length === 1) {
      return sensor[0];
    } else if (sensor.length === 2 && sensor?.includes('NOH')) {
      return 'PLUS';
    } else {
      return 'DUAL';
    }
  } catch {
    return '';
  }
};

export const getDevice = (device: string) => {
  if (device === 'NOM') {
    return ['NOM'];
  } else if (device === 'DUAL') {
    return ['NOM', 'NOM'];
  } else {
    return ['NOM', 'NOH'];
  }
};
